import styled from "@emotion/styled";
import { Loader as MLoader, type LoaderProps } from "@mantine/core";
import { type CSSProperties } from "react";

const LoaderBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

interface Props extends LoaderProps {
  wrapperStyle?: CSSProperties;
}

const Loader = ({ wrapperStyle, ...loaderProps }: Props) => (
  <LoaderBox style={wrapperStyle}>
    <MLoader {...loaderProps} />
  </LoaderBox>
);

export default Loader;
